<template>
  <div class="meeting_group">
    <div class="form_box">
      <el-form :model="forms" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
        :label-position="'left'">
        <div class="form_top">
          <div class="form_top_right">
            <el-form-item label="会议组名称" prop="className">
              <el-input class="inputWith" v-model="forms.className" :autocomplete="'on'"></el-input>
            </el-form-item>
            <el-form-item label="邀请人" prop="userIds">
              <el-select class="inputWith" v-model="forms.userIds" filterable remote reserve-keyword
                :remote-method="searchKeyword" multiple placeholder="请选择">
                <el-option class="inputWith" v-for="item in this.userList" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form_btn">
          <el-form-item>
            <el-button type="primary" @click="handleSubmit()">保存
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
// import baseEdit from "@/views/components/base/baseEdit.vue";
let pinyin = require('js-pinyin');
export default {
  components: {},
  data() {
    return {
      mname: "",
      key: "id",
      url: {
        get: "/admin/system/meetingClass",
        edit: "/admin/system/meetingClass",
      },
      id: "",
      typeId: "",
      // items: [
      //   { label: "新增会议组", type: "header" },
      //   {
      //     label: "会议组名称",
      //     name: "className",
      //     value: "",
      //     type: "input",
      //     width: "500px",
      //     rules: [{ required: true, trigger: "blur" }],
      //   },
      //   {
      //     label: "邀请人",
      //     name: "userIds",
      //     value: "",
      //     type: "multiple",
      //     remoteMethod: this.searchKeyword,
      //     filterable: true,
      //     remote: true,
      //     loading: false,
      //     width: "500px",
      //     dropList: [],
      //     rules: [{ required: true, trigger: "blur", type: "array" }],
      //   },

      // ],
      forms: {},
      userList: [],
    };
  },
  props: ["onCancel", "id", "type"],
  created() {
    if (this.type === "edit") {
      this.id = this.id;
      this.handleSearch();
    }
    this.loaduserData();
  },
  methods: {
    searchKeyword(e) {
      pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
      if (e !== '') {
        let q = {};
        $utils.api.load("/admin/system/user/listAll", q).then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.nickName;
              dropList.push(xx);
            }
            let pinyinStr = pinyin.getCamelChars(e)
            let list = []
            if (e === pinyinStr) {
              for (let i = 0; i < dropList.length; i++) {
                let upPinYin = ""
                let fullPinYin = ""
                if (dropList[i].name) {
                  upPinYin = pinyin.getCamelChars(dropList[i].name);
                  fullPinYin = pinyin.getFullChars(dropList[i].name);
                }
                if (fullPinYin.toUpperCase().includes(pinyinStr.toUpperCase())
                  || upPinYin.toUpperCase().includes(pinyinStr.toUpperCase())) {
                  list.push(dropList[i])
                }
              }
            } else {
              for (let i = 0; i < dropList.length; i++) {
                if (dropList[i].name) {
                  if (dropList[i].name.includes(e)) {
                    list.push(dropList[i])
                  }
                }
              }
            }
            this.userList = list
          }
        });
      }else{
        this.loaduserData()
      }
    },
    async handleSearch() {
      let res = await $utils.api.load(`/admin/system/meetingClass/${this.id}`);
      try {
        if (res) {
          this.forms = res.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/user/listAll", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          this.userList = dropList
        }
      });
    },
    handleSubmit() {
      let q = this.forms;
      console.log(q);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/meetingClass`, q, this.type == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$emit("onCancel");
                $utils.url.go(0);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.meeting_group {
  .form_box {
    .inputWith {
      width: 400px;
    }

    .inputWithTime {
      width: 200px;
    }

    .form_top,
    .form_bottom {
      display: flex;
    }

    .form_top {
      margin-bottom: 40px;

      .facilityType_class {
        padding-left: 100px;
        color: red;
        cursor: pointer;
      }

      .center-02 {
        width: 300px;
        border-radius: 10px;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 1px 2px 5px #8c939d;
        margin-left: 10px;
      }
    }

    .form_top_left,
    .form_bottom_left {
      width: 150px;
    }

    .form_top_left_text,
    .form_bottom_left_text {
      height: 40px;
      line-height: 40px;
      margin: 0 40px;
    }

    .form_bottom {
      margin-bottom: 20px;
    }

    .form_btn {
      margin-left: 150px;
    }
  }
}
</style>
